import { Circle, MapContainer, TileLayer, useMapEvents } from "react-leaflet";
import { BASEMAP } from "../map/basemap";

function ClickCatcher({ onPick }: { onPick: (lat: number, lon: number) => void }) {
  useMapEvents({ click: (e) => onPick(e.latlng.lat, e.latlng.lng) });
  return null;
}

/**
 * A small map showing the zone a rule describes.
 *
 * The radius is a number in a form, and a number in a form is impossible to judge — 2,000 m
 * means nothing until you see it sitting over your street. For a fixed-anchor rule the map is
 * also how the centre gets set: tap it.
 */
export default function ZonePreview({
  lat,
  lon,
  radiusM,
  editable,
  onPick,
}: {
  lat: number | null;
  lon: number | null;
  radiusM: number;
  editable: boolean;
  onPick?: (lat: number, lon: number) => void;
}) {
  if (lat === null || lon === null) return null;

  // Fit the circle with a little air around it. 2.6 diameters of span reads as "this circle,
  // in its surroundings" rather than a blue disc filling the frame.
  const zoom = Math.round(Math.log2((40_075_017 * Math.cos((lat * Math.PI) / 180)) / (radiusM * 2.6 * 2)) - 8);

  return (
    <div className="zone-preview">
      <MapContainer
        center={[lat, lon]}
        zoom={Math.max(8, Math.min(15, zoom))}
        zoomControl={false}
        attributionControl={false}
        dragging={editable}
        scrollWheelZoom={false}
        doubleClickZoom={false}
        className="zone-map"
      >
        <TileLayer url={BASEMAP.url} maxNativeZoom={BASEMAP.maxNativeZoom} maxZoom={BASEMAP.maxZoom} />
        <Circle
          center={[lat, lon]}
          radius={radiusM}
          pathOptions={{ color: "#4da3ff", fillColor: "#4da3ff", fillOpacity: 0.15, weight: 2 }}
        />
        {editable && onPick && <ClickCatcher onPick={onPick} />}
      </MapContainer>
    </div>
  );
}
